import React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { 
  APP_ROUTES,
  MAIN_ROUTES
} from '../../_config/routes';
import { MENU, hasRol } from '../../_config/menu';
import DropdownNavButton from '../../containers/menus/dropdown_nav_button';
import { cleanValues, getRol, getUserName } from '../../_utils/storage_handler';
import { Link } from 'react-router-dom';


const MainAppBar = () => {

  let userName = getUserName();

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar style={{backgroundColor: '#1d82e6'}} position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <img src={require('../../assets/imgs/ks_logo_white.png')} style={{marginRight: '30px'}} width={28} alt={'Koala Software'} />
                <span style={{marginRight: '20px', fontWeight: 'bold'}}>Hola, {userName}</span>
            </div>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {/** Menu responsive */}
              <div style={{backgroundColor: '#1d82e6', display: 'flex', flexDirection: 'column'}}>
                {MENU.map((page, key) => {
                  if(hasRol(getRol(),page.roles)){
                    return page.path ? 
                      <Link key={key + 'cmd'} to={page.path}>
                        <Button
                          style={{margin: '0 10px 0 10px', color: '#eee'}}
                          variant="text"
                          disableElevation
                          onClick={() => handleCloseNavMenu()}
                        >
                            {page.label}
                        </Button>
                      </Link>
                    :
                      <DropdownNavButton
                        key={key + 'md'}
                        prefixKey={'cmd'}
                        label={page.label}
                        submenu={page.children}
                        closeRoot={()=>{handleCloseNavMenu();}}
                      />
                  } else {
                    return(<div key={key + 'md'}></div>);
                  }
                })}
              </div>
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {MENU.map((page, key) => {
              if(hasRol(getRol(),page.roles)){
                return page.path ? 
                  <Link key={key + 'cmd'} to={page.path}>
                    <Button
                        style={{margin: '0 10px 0 10px', color: '#eee'}}
                        variant="text"
                        disableElevation
                      >
                          {page.label}
                      </Button>
                  </Link>
                :
                  <DropdownNavButton
                    key={key + 'md'}
                    prefixKey={'cmd'}
                    label={page.label}
                    submenu={page.children}
                    closeRoot={()=>{}}
                  />
              } else {
                return(<div key={key + 'md'}></div>);
              }
            })}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Koala Software" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <div>
                <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.profile}`}>
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Typography textAlign="center">Perfil</Typography>
                  </MenuItem>
                </Link>
                <MenuItem 
                  onClick={() => {
                    cleanValues();
                    window.location.href = '/';
                  }}
                >
                  <Typography style={{color:'red'}} textAlign="center">Salir</Typography>
                </MenuItem>
              </div>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default MainAppBar;